import React from 'react';

const ActivityTableSkeleton = () => {
  return (
    <div className="bg-card rounded-xl shadow-wellness elevation-1 border border-border/40 overflow-hidden">
      {/* Header Skeleton */}
      <div className="p-6 border-b border-border/40">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-muted/50 rounded-lg animate-pulse" />
          <div className="flex-1">
            <div className="h-5 w-32 bg-muted/50 rounded animate-pulse mb-2" />
            <div className="h-4 w-48 bg-muted/50 rounded animate-pulse" />
          </div>
        </div>
      </div>
      {/* Desktop Table Skeleton */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/30">
            <tr>
              <th className="px-6 py-4 text-left">
                <div className="h-4 w-16 bg-muted/50 rounded animate-pulse" />
              </th>
              <th className="px-6 py-4 text-left">
                <div className="h-4 w-20 bg-muted/50 rounded animate-pulse" />
              </th>
              <th className="px-6 py-4 text-left">
                <div className="h-4 w-20 bg-muted/50 rounded animate-pulse" />
              </th>
              <th className="px-6 py-4 text-left">
                <div className="h-4 w-20 bg-muted/50 rounded animate-pulse" />
              </th>
              <th className="px-6 py-4 text-left">
                <div className="h-4 w-16 bg-muted/50 rounded animate-pulse" />
              </th>
              <th className="px-6 py-4 text-left">
                <div className="h-4 w-20 bg-muted/50 rounded animate-pulse" />
              </th>
              <th className="px-6 py-4 text-left">
                <div className="h-4 w-16 bg-muted/50 rounded animate-pulse" />
              </th>
              <th className="px-6 py-4 text-right">
                <div className="h-4 w-16 bg-muted/50 rounded animate-pulse ml-auto" />
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border/40">
            {[...Array(5)]?.map((_, index) => (
              <tr key={index} className="animate-pulse">
                <td className="px-6 py-4">
                  <div className="space-y-2">
                    <div className="h-4 w-20 bg-muted/50 rounded" />
                    <div className="h-3 w-16 bg-muted/50 rounded" />
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-muted/50 rounded-lg" />
                    <div className="space-y-2">
                      <div className="h-4 w-24 bg-muted/50 rounded" />
                      <div className="h-3 w-32 bg-muted/50 rounded" />
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div className="h-4 w-16 bg-muted/50 rounded" />
                </td>
                <td className="px-6 py-4">
                  <div className="h-4 w-16 bg-muted/50 rounded" />
                </td>
                <td className="px-6 py-4">
                  <div className="h-4 w-20 bg-muted/50 rounded" />
                </td>
                <td className="px-6 py-4">
                  <div className="h-6 w-20 bg-muted/50 rounded-full" />
                </td>
                <td className="px-6 py-4">
                  <div className="h-6 w-16 bg-muted/50 rounded-full" />
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center justify-end space-x-2">
                    <div className="w-8 h-8 bg-muted/50 rounded" />
                    <div className="w-8 h-8 bg-muted/50 rounded" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Mobile Cards Skeleton */}
      <div className="md:hidden divide-y divide-border/40">
        {[...Array(3)]?.map((_, index) => (
          <div key={index} className="p-4 animate-pulse">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-muted/50 rounded-lg" />
                <div className="space-y-2">
                  <div className="h-4 w-24 bg-muted/50 rounded" />
                  <div className="h-3 w-32 bg-muted/50 rounded" />
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-muted/50 rounded" />
                <div className="w-8 h-8 bg-muted/50 rounded" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="h-4 w-full bg-muted/50 rounded" />
              <div className="h-4 w-full bg-muted/50 rounded" />
              <div className="h-4 w-full bg-muted/50 rounded" />
              <div className="h-4 w-full bg-muted/50 rounded" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityTableSkeleton;